import script from "./QueryTemplateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryTemplateModal.vue?vue&type=script&setup=true&lang=js"

import "./QueryTemplateModal.vue?vue&type=style&index=0&id=fad6a596&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fad6a596"]])

export default __exports__